import { render, staticRenderFns } from "./CombiCashFormItem.vue?vue&type=template&id=038c7458"
import script from "./CombiCashFormItem.vue?vue&type=script&lang=js"
export * from "./CombiCashFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports